"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const stockpile_style_1 = __importDefault(require("../stockpile.style"));
const stockpile_action_1 = __importDefault(require("../stockpile.action"));
const stockpile_column_1 = require("../stockpile.column");
const grid_1 = __importDefault(require("components/templates/grid"));
const modal_1 = require("components/molecules/modal");
const AdjustmentStockpileDeletedList = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isLoadingDeleted, mutationMode, dataGridDeletedList, dataStatesDeletedList } = (0, store_1.useAppSelector)(state => state.adjustment.stockpile);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'deleted_list') {
            dispatch(stockpile_action_1.default.getDataGridDeletedList(dataStatesDeletedList));
        }
    }, [mutationMode]);
    const onFilterChangeDeletedList = (e) => {
        dispatch(stockpile_action_1.default.onFilterChangeDeletedList(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStatesDeletedList), { filter: e.filter });
        dispatch(stockpile_action_1.default.getDataGridDeletedList(newDataStates));
    };
    const onSortChangeDeletedList = (e) => {
        dispatch(stockpile_action_1.default.onSortChangeDeletedList(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStatesDeletedList), { sort: e.sort });
        dispatch(stockpile_action_1.default.getDataGridDeletedList(newDataStates));
    };
    const onDataStateChangeDeletedList = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesDeletedList), { skip: types === 'page' ? (val - 1) * dataStatesDeletedList.take : 0, take: types === 'take' ? val : dataStatesDeletedList.take });
        dispatch(stockpile_action_1.default.onDataStateChangeDeletedList(newDataStates));
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ appTheme: appTheme, modalTitle: 'Deleted List', isLoading: isLoadingDeleted, show: mutationMode === 'deleted_list', style: stockpile_style_1.default.modalContainerDeletedList(appTheme), handleClose: () => dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: false })) }, { children: (0, jsx_runtime_1.jsx)(grid_1.default, { sortable: true, pageable: true, cardGrid: false, scrollable: 'scrollable', dataGrid: dataGridDeletedList, sort: dataStatesDeletedList.sort, dataStates: dataStatesDeletedList, columns: stockpile_column_1.DeletedListColumnProps, onSortChange: onSortChangeDeletedList, style: stockpile_style_1.default.gridHeightDeletedList, onFilterChange: onFilterChangeDeletedList, onPageChange: (v) => onDataStateChangeDeletedList('page', v), onTakeChange: (v) => onDataStateChangeDeletedList('take', v) }) })) }));
};
exports.default = AdjustmentStockpileDeletedList;
